// extracted by mini-css-extract-plugin
export default {"container":"Selector_container__IRzmI","items_container":"Selector_items_container__f27jv","item_container":"Selector_item_container__Ht3ZE","indicator":"Selector_indicator__EDt18"};